import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { BremaLogo } from "@/components/BremaLogo";
import { Loader2, AlertTriangle } from "lucide-react";

export default function MagicLogin() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("Link non valido."); return; }
    api.post("/auth/magic-login", { token })
      .then(({ data }) => {
        localStorage.setItem("brema_token", data.access_token);
        window.location.replace(data.user?.role === "admin" ? "/" : "/portal");
      })
      .catch((e) => setError(formatApiError(e.response?.data?.detail) || "Accesso non riuscito."));
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-brema-bg px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-brema-card p-8 text-center" data-testid="magic-login-page">
        <div className="mb-6 flex justify-center"><BremaLogo /></div>
        {!error ? (
          <>
            <Loader2 className="mx-auto mb-4 h-8 w-8 animate-spin text-brand" />
            <p className="text-foreground">Accesso in corso al Portale B2B…</p>
          </>
        ) : (
          <>
            <AlertTriangle className="mx-auto mb-4 h-8 w-8 text-brema-red" />
            <p className="mb-4 text-foreground" data-testid="magic-login-error">{error}</p>
            <Link to="/login" className="text-sm font-semibold text-brand hover:underline" data-testid="magic-login-to-login">Vai al login</Link>
          </>
        )}
      </div>
    </div>
  );
}
